export const settings_page = (t) => ({
	SETTINGS_PAGE_HEADER: {
		value: 'GAME SETTINGS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 55,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	SETTINGS_ITEM_INFO: {
		value: '',
		config: {
			fill: '#396AA4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	SETTINGS_ITEM_TITLE: {
		value: '',
		config: {
			fill: '#D6C06C',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	SETTINGS_ITEM_DESC: {
		value: '',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	SETTINGS_ITEM_INFO_SFX: {
		value: t('settings.sound_fx')
	},
	SETTINGS_ITEM_INFO_FUNC: {
		value: t('settings.functional')
	},
	SETTINGS_ITEM_INFO_VISUAL: {
		value: t('settings.visual')
	},
	SETTINGS_ITEM_TITLE_SFX_BG: {
		value: t('settings.background_music')
	},
	SETTINGS_ITEM_DESC_SFX_BG: {
		value: t('settings.background_music_desc')
	},
	SETTINGS_ITEM_TITLE_SFX_SE: {
		value: t('settings.sound_effects')
	},
	SETTINGS_ITEM_DESC_SFX_SE: {
		value: t('settings.sound_effects_desc')
	},
	SETTINGS_ITEM_TITLE_FUNC_RS: {
		value: t('settings.fast_spin')
	},
	SETTINGS_ITEM_DESC_FUNC_RS: {
		value: t('settings.fast_spin_desc')
	},
	SETTINGS_ITEM_TITLE_FUNC_GA: {
		value: t('settings.game_animations')
	},
	SETTINGS_ITEM_DESC_FUNC_GA: {
		value: t('settings.game_animations_desc')
	},
	SETTINGS_ITEM_TITLE_VISUAL_KS: {
		value: t('settings.keyboard_shortcuts')
	},
	SETTINGS_ITEM_DESC_VISUAL_KS: {
		value: t('settings.keyboard_shortcuts_desc')
	},
	SETTINGS_ITEM_TITLE_FUNC_SS: {
		value: t('settings.splash_screen')
	},
	SETTINGS_ITEM_DESC_SS_DESC: {
		value: t('settings.splash_screen_desc')
	}
});
